/* Import Module */
import { searchParams } from "../variables";

/* Define Script */
const moveSearchParams = async (request: any) => {
  searchParams.start_ymd = request.start_ymd;
  searchParams.end_ymd = request.end_ymd;
  searchParams.user_id = request.user_id;
  searchParams.car_id = request.car_id;
  searchParams.car_model_id = request.car_model_id;
  searchParams.car = request.car;
  searchParams.department_id = request.department_id;
  searchParams.type_id = request.type_id;
};

export const setSearchParams = async (request: any) => {
  await moveSearchParams(request);
};
